import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";

import { store } from "./store";
import { PrintContextProvider } from "./context/PrintContext";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

let persistor = persistStore(store);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <PrintContextProvider>
          <App />
        </PrintContextProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
